import { render, staticRenderFns } from "./treeMenu.vue?vue&type=template&id=4e82f936&scoped=true"
import script from "./treeMenu.vue?vue&type=script&lang=js"
export * from "./treeMenu.vue?vue&type=script&lang=js"
import style0 from "./treeMenu.vue?vue&type=style&index=0&id=4e82f936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e82f936",
  null
  
)

export default component.exports